<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-title class="text-h4 px-0">
              {{ $t("report.thgInsuranceCheck.title") }}
            </v-card-title>
            <v-card-subtitle class="pl-0"> {{ $t("report.thgInsuranceCheck.description") }} </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-1">
          <v-card outlined flat>
            <div
              style="width: 100%; height: 100%; overflow: hidden"
              id="tcpp-iframe-kfz"
              data-style="custom_green"
              :data-tracking="partner._id"
              class="tarif-check-iframe-wrapper ml-n2"
            ></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import LayoutReport from "@/layouts/LayoutReport.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutReport }
})
export default class ThgInsuranceCheck extends Vue {
  get color() {
    return getDefaultPartnerColor();
  }

  get partner() {
    return ReportModule.partner;
  }

  mounted() {
    const widgetScript = document.createElement("script");
    widgetScript.setAttribute(
      "src",
      "https://form.partner-versicherung.de/widgets/133924/tcpp-iframe-kfz/kfz-iframe.js"
    );
    document.head.appendChild(widgetScript);
  }
}
</script>
<style>
.tarif-check-iframe-wrapper > iframe {
  /* Hide the nasty grey boarder */
  transform: translateX(15px) !important;
}
</style>
